import { attivita } from "./attivita.ts";
import { avvio } from "./avvio.ts";
import { comune } from "./comune.ts";
import { compose } from "./compose.ts";
import { editor } from "./editor.ts";
import { email } from "./email.ts";
import { errori } from "./errori.ts";
import { guscio } from "./guscio.ts";
import { impostazioni } from "./impostazioni.ts";
import { log } from "./log.ts";
import { pagine } from "./pagine.ts";
import { rilascio } from "./rilascio.ts";
import { rilascioUi } from "./rilascioUi.ts";
import { risorse } from "./risorse.ts";
import { stack } from "./stack.ts";

/**
 * Il catalogo italiano: la fonte da cui ogni altra lingua prende la forma.
 *
 * Ogni area vive nel suo file con chiavi `"<area>.<nome>"`; qui si uniscono in
 * un oggetto piatto, così una chiave è una stringa che può anche viaggiare
 * dal server all'interfaccia.
 */
export const it = {
  ...attivita,
  ...avvio,
  ...comune,
  ...compose,
  ...editor,
  ...email,
  ...errori,
  ...guscio,
  ...impostazioni,
  ...log,
  ...pagine,
  ...rilascio,
  ...rilascioUi,
  ...risorse,
  ...stack,
};
